// extracted by mini-css-extract-plugin
export default {"spinner":"spinner__TDbzi","rotator":"rotator__IziI4","path":"path__XxBuo","dash":"dash__5mDJn","colors":"colors__5OdYu"};